document.addEventListener('DOMContentLoaded', () => {
    bindAuthOpen();
});

let escHandler = null;

function bindAuthOpen() {
    const openBtns = document.querySelectorAll('.auth-open-btn');
    if (!openBtns.length) return;

    openBtns.forEach((btn) => {
        btn.addEventListener('click', async (e) => {
            e.preventDefault();

            const existingModal = document.querySelector('.auth-modal');
            if (existingModal) {
                openModal(existingModal);
                return;
            }

            const formData = new FormData();
            formData.append('POPUP_AUTH', 'Y');

            const response = await fetch('/auth/', {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            });

            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const modal = doc.querySelector('.auth-modal');

            if (!modal) return;

            document.body.insertAdjacentHTML('beforeend', modal.outerHTML);
            const insertedModal = document.querySelector('.auth-modal');

            const burgerButton = document.getElementById('header-mobile__burger_check');
            if (burgerButton && btn.classList.contains('auth-open-btn__mobile')) {
                burgerButton.click();
            }

            openModal(insertedModal);
        });
    });
}

function openModal(modal) {
    bindAuthModal(modal);
    bindForgotPasswordLink(modal);
    bindAuthForm(modal);
    document.body.style.overflow = 'hidden';
    modal.classList.add('is-open');
}

function bindAuthModal(modal) {
    if (!modal) return;

    const closeBtn = modal.querySelector('#auth-modal-close');

    closeBtn?.addEventListener('click', () => closeModal(modal));

    if (escHandler) {
        document.removeEventListener('keydown', escHandler);
    }

    escHandler = (e) => {
        if (e.key === 'Escape') {
            closeModal(modal);
        }
    };

    document.addEventListener('keydown', escHandler);
}

function closeModal(modal) {
    if (!modal) return;

    const isChangePasswordSuccess = modal.querySelector('#auth-change-pass__suc');

    modal.remove();
    document.body.style.overflow = '';

    if (escHandler) {
        document.removeEventListener('keydown', escHandler);
        escHandler = null;
    }

    if (isChangePasswordSuccess) {
        window.location.replace('/');
    }
}

function bindAuthForm(modal) {
    const form = modal.querySelector('#authorization-form');
    if (!form) return;

    form.onsubmit = async (event) => {
        event.preventDefault();

        const submitButton = form.querySelector('[type="submit"]');
        if (!submitButton || submitButton.disabled) return;

        submitButton.disabled = true;

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin',
            });

            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const hasErrors = doc.querySelector('.auth-common-errors') !== null;

            if (hasErrors) {
                const newAuthBlock = doc.querySelector('#ajax_auth');
                const currentAuthBlock = document.querySelector('#ajax_auth');
                if (currentAuthBlock && newAuthBlock) {
                    currentAuthBlock.innerHTML = newAuthBlock.innerHTML;
                    const newForm = document.querySelector('#authorization-form');
                    if (newForm) {
                        bindAuthForm(modal);
                    }
                }
            } else {
                window.location.reload();
            }
        } catch (error) {
            submitButton.disabled = false;
        }
    };
}

function bindForgotPasswordLink(modal) {
    const link = modal.querySelector('.forgot-password-link');

    if (!link) return;

    link.onclick = async (e) => {
        e.preventDefault();

        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('POPUP_AUTH', 'Y');
        const response = await fetch(url.toString(), {
            credentials: 'same-origin',
        });

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newModal = doc.querySelector('.auth-modal');

        if (!newModal) {
            window.location.href = link.href;
            return;
        }

        modal.outerHTML = newModal.outerHTML;
        const insertedModal = document.querySelector('.auth-modal');

        bindAuthModal(insertedModal);
        bindForgotPasswordForm(insertedModal);
    };
}

function bindForgotPasswordForm(modal) {
    const form = modal.querySelector('#forgot-password-form');

    if (!form) return;

    form.onsubmit = async (event) => {
        event.preventDefault();

        const submitButton = form.querySelector('[type="submit"]');

        if (!submitButton || submitButton.disabled) return;

        submitButton.disabled = true;

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin',
            });

            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newBlock = doc.querySelector('#ajax_forgot_password');
            const currentBlock = modal.querySelector('#ajax_forgot_password');

            if (currentBlock && newBlock) {
                currentBlock.innerHTML = newBlock.innerHTML;
                bindForgotPasswordForm(modal);
            }

            const header = document.querySelector('.form-header__title');
            if (header) {
                header.textContent = 'Успешно!';
            }
        } catch (error) {
            submitButton.disabled = false;
        }
    };
}

document.addEventListener('DOMContentLoaded', () => {
    const modal = document.querySelector('.auth-modal');
    if (modal) {
        bindAuthModal(modal);
    }
});
